export default "__VITE_ASSET__D73GYRFk__"